import { HeaderTabLink } from "@prismicio/editor-ui"

import { SettingsPage } from "../SettingsPage"
import { SettingsPageBodyHeader } from "../SettingsPageBodyHeader"
import { SettingsPageBodyTabs } from "../SettingsPageBodyTabs"
import { UploadCompaniesTabContent } from "./UploadCompaniesTabContent"

export function PrismicAgentPage() {
  return (
    <SettingsPage pageName="Prismic Agent">
      <SettingsPageBodyHeader
        title="Prismic Agent"
        description="AI-powered content generation"
      />
      <SettingsPageBodyTabs>
        <HeaderTabLink text="CRM" selected />
      </SettingsPageBodyTabs>
      <UploadCompaniesTabContent />
    </SettingsPage>
  )
}
